import React from 'react';

const ChevRightIcon = ({ size = 14, ...props }) => (
  <svg
    width={Math.round((size * 12) / 18)}
    height={size}
    viewBox='0 0 12 18'
    fill='currentColor'
    {...props}>
    <path
      d='M 1.433 18 L 0 16.208 L 8.865 8.731 L 3.306 1.428 L 5.084 0 L 12 9.087 L 1.433 18 Z'
      fillRule='nonzero'
    />
  </svg>
);

export default ChevRightIcon;
